module.exports = {
      id: "hamburger--md-usage",
      viewBox: "0 0 25 16",
      url: __webpack_public_path__ + "images/sprites/ui.svg#hamburger--md-usage",
      toString: function () {
        return this.url;
      }
    }